module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "human-staff-list"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Human Staff List')))])])]), (_vm.searchCallbackFlag) ? _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Human Staff List')))]) : _vm._e(), ((_vm.humanStaffs != null && _vm.humanStaffs.length > 0) && _vm.searchCallbackFlag) ? _c('div', [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": _vm.onClickSave
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])])])])]), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_vm._m(0), _c('tbody', _vm._l((_vm.humanStaffs), function(humanStaff, index) {
    return _c('tr', {
      class: _vm.isCheck(humanStaff.id)
    }, [_c('td', {
      staticClass: "text-center"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.humanStaffIds),
        expression: "humanStaffIds"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": humanStaff.id,
        "checked": Array.isArray(_vm.humanStaffIds) ? _vm._i(_vm.humanStaffIds, humanStaff.id) > -1 : (_vm.humanStaffIds)
      },
      on: {
        "click": function($event) {
          var $$a = _vm.humanStaffIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = humanStaff.id,
              $$i = _vm._i($$a, $$v);
            if ($$c) {
              $$i < 0 && (_vm.humanStaffIds = $$a.concat($$v))
            } else {
              $$i > -1 && (_vm.humanStaffIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.humanStaffIds = $$c
          }
        }
      }
    })]), _c('td', [_vm._v(_vm._s(humanStaff.attributes['user-name']) + " " + _vm._s(humanStaff.attributes['user-firstname']))]), _c('td', [_vm._v(_vm._s(humanStaff.attributes['user-type-name']))])])
  }))])])]), ((_vm.humanStaffs == null || _vm.humanStaffs.length == 0) && _vm.searchCallbackFlag) ? _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "alert alert-warning"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('No Data')))])])])]) : _vm._e()]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', {
    staticClass: "info"
  }, [_c('th', {
    staticClass: "col-sm-1"
  }), _c('th', {
    staticClass: "col-sm-4"
  }, [_vm._v("社員名")]), _c('th', {
    staticClass: "col-sm-7"
  }, [_vm._v("役職")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-25b3efc7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/human-staff-list.pug
// module id = 788
// module chunks = 1